module.exports = __webpack_public_path__ + "img/number1.1600c95f.png";